const totalNightTextSetter = (totalNights) =>
  totalNights === 1 ? '1 noche' : `${totalNights} noches`;

export default totalNightTextSetter;
